import authService from './authService';
import { ensureOk, readData, readList, toQuery } from './apiResponse';
import type { RecurrenceFormData, RecurrenceRule } from '../types/planning';

class RecurrenceService {
  private async getApiClient() {
    return authService.getApiClient();
  }

  /** GET /recurrences?include_inactive= */
  async getAll(includeInactive = false): Promise<RecurrenceRule[]> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/recurrences${toQuery({ include_inactive: includeInactive })}`);
    return readList<RecurrenceRule>(response, 'Falha ao buscar as recorrências');
  }

  /** GET /recurrences/:id */
  async getById(id: number): Promise<RecurrenceRule> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.get(`/recurrences/${id}`);
    return readData<RecurrenceRule>(response, 'Falha ao buscar a recorrência');
  }

  /** POST /recurrences */
  async create(formData: RecurrenceFormData): Promise<RecurrenceRule> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.post('/recurrences', formData);
    return readData<RecurrenceRule>(response, 'Falha ao criar a recorrência');
  }

  /** PUT /recurrences/:id */
  async update(id: number, formData: RecurrenceFormData): Promise<RecurrenceRule> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.put(`/recurrences/${id}`, formData);
    return readData<RecurrenceRule>(response, 'Falha ao atualizar a recorrência');
  }

  /** DELETE /recurrences/:id (encerra a regra) */
  async end(id: number): Promise<void> {
    const apiClient = await this.getApiClient();
    const response = await apiClient.delete(`/recurrences/${id}`);
    await ensureOk(response, 'Falha ao encerrar a recorrência');
  }
}

export const recurrenceService = new RecurrenceService();
export default recurrenceService;
